import { Router } from '@angular/router';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AppContext } from 'src/app/services/app-context.service';
// import { AppContext } from 'src/app/shared-components/shared-components.module';
// import { debugOutputAstAsTypeScript } from '@angular/compiler';

@Component({
  selector: 'travel-ui-set-context',
  templateUrl: './set-context.component.html',
  styleUrls: ['./set-context.component.scss']
})
export class SetContextComponent implements OnInit {

  channelId: any;
  accountId: any;

  constructor(
    public appContextService: AppContext,
    public router: Router,
    private dialogRef: MatDialogRef<SetContextComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.appContextService.getContext()
      .subscribe((res) => {
        if (res) {
          this.channelId = res.channelId;
          this.accountId = res.accountId
        }
      });
  }

  close() {
    this.dialogRef.close(false);
  }

  continue() {
    this.appContextService.setContext(this.channelId, this.accountId)
      .subscribe((res) => {
        if (res) {
          this.close();
        }
      })
  }

}
